// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_3xQbF","first-story":"_1kbmI","ad":"_2LXXI"};